import axios from "axios"
import authAxios from "./axios-instance/authAxios";

const mainApiHost = process.env.REACT_APP_MAIN_API_HOST;

export function LinkItemsApi(props) {
    return {
        searchListByOwner: async ({ params, headers }) => {
            return await authAxios.get(`${mainApiHost}/link-items/user-pages/${params?.userPageId}/owner`, {
                params: {
                    searchQuery: params?.searchQuery,
                    lcId: params?.lcId,
                    offset: params?.offset,
                    limit: params?.limit
                },
                headers: headers,
                withCredentials: true
            })
        },
        searchListByGuest: async ({ params, headers }) => {
            return await axios.get(`${mainApiHost}/link-items/user-pages/${params?.userPageId}/guest`, {
                params: {
                    searchQuery: params?.searchQuery,
                    lcId: params?.lcId,
                    offset: params?.offset,
                    limit: params?.limit
                },
                headers: headers
            })
        },
        create: async ({ body, headers }) => {
            return await authAxios.post(`${mainApiHost}/link-items/create`, body, {
                headers: headers,
                withCredentials: true
            })
        },
        delete: async ({ body, headers }) => {
            return await authAxios.delete(`${mainApiHost}/link-items`, {
                data: body,
                headers: headers,
                withCredentials: true
            })
        },
        updateInfo: async ({ body, headers }) => {
            return await authAxios.patch(`${mainApiHost}/link-items/update/info`, body, {
                headers: headers,
                withCredentials: true
            })
        },
        updateIsHide: async ({ body, headers }) => {
            return await authAxios.patch(`${mainApiHost}/link-items/update/isHide`, body, {
                headers: headers,
                withCredentials: true
            })
        },
        changeList_orderNumber: async ({ body, headers }) => {
            return await authAxios.patch(`${mainApiHost}/link-items/list/orderNumber`, body, {
                headers: headers,
                withCredentials: true
            })
        },
    }
}